package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.JustifyContent


val ArrowWhiteImageStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("width", "0px")
            property("opacity", "0")
            property("margin-left", "0px")
            property("transition",
                "width 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                        "opacity 300ms ease, " +
                        "margin-left 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0)"
            )
            property("overflow", "hidden")
            property("flex-shrink", "0")
        }
    }
}

val CountryButtonStyle = CssStyle {
    base {
        Modifier
            .border( width = 1.px, style = LineStyle.Solid, Colors.DarkBlue)
            .color(Colors.DarkBlue)
            .backgroundColor(Color.transparent)
            .padding(
                topBottom = 10.px,
                leftRight = 15.px
            )
            .styleModifier {
                property(
                    propertyName = "transition",
                    value = "background-image 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                            "color 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                            "width 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0), " +
                            "padding 400ms cubic-bezier(0.2, 1.2, 0.2, 1.0)"
                )
            }
    }
    Breakpoint.MD {
        Modifier
            .border(2.px, LineStyle.Solid, Colors.DarkBlue)
            .padding(
                topBottom = 35.px,
                leftRight = 35.px
            )
    }

    Breakpoint.XL {
        Modifier.width(270.px)
    }

    Breakpoint.LG {
        Modifier.width(270.px)
    }
    hover {
        Modifier
            .scale(1.06)
            .width(310.px)
            .border(0.px, LineStyle.Solid, Colors.DarkBlue)
            .backgroundImage(
                gradient = linearGradient(
                    from = Colors.DarkBlue,
                    to = Colors.linear,
                    dir = LinearGradient.Direction.ToRight
                )
            )
            .color(Colors.White)
    }
    cssRule(":hover img") {
        Modifier.styleModifier {
            property("width", "40px")
            property("opacity", "1")
            property("margin-left", "10px")
        }
    }
}

// Container principal
val CountrySectionContainerStyle = CssStyle {
    base {
        Modifier.padding(top = 30.px, bottom = 40.px)
    }
}

// Titre Mobile (Visible en base, masqué sur MD+)
val CountryTitleMobileStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Flex)
            .margin(bottom = 15.px)
            .padding(leftRight = 16.px)
    }
    Breakpoint.MD {
        Modifier.display(DisplayStyle.None)
    }
}

// Titre Desktop (Masqué en base, visible sur MD+)
val CountryTitleDesktopStyle = CssStyle {
    base {
        Modifier.display(DisplayStyle.None)
    }
    Breakpoint.MD {
        Modifier
            .display(DisplayStyle.Flex)
            .margin(bottom = 20.px)
    }
}

// Paragraphes de description
val CountryDescriptionTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(15.px)
            .padding(leftRight = 15.px)
//            .margin(bottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(20.px)
            .padding(leftRight = 0.px)
//            .margin(bottom = 0.px)
    }
}
// Paragraphes de description
val CountryDescriptionsubTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(15.px)
            .padding(leftRight = 15.px)
            .margin(bottom = 10.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(20.px)
            .padding(leftRight = 0.px)
            .margin(bottom = 0.px)
    }
}

// Alignement des cartes
val CountryCardsRowStyle = CssStyle {
    base {
        Modifier
            .margin(bottom = 10.px)
            .gap(10.px)
            .justifyContent(JustifyContent.Center)
    }
    Breakpoint.MD {
        Modifier
            .margin(bottom = 20.px)
            .gap(80.px)
    }
}

// Bouton principal
val CountryButtonResponsiveStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .padding(topBottom = 10.px, leftRight = 15.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(30.px)
            .padding(topBottom = 35.px, leftRight = 35.px)
    }
}

// Flèche du bouton
val CountryButtonArrowStyle = CssStyle {
    base { Modifier.height(20.px) }
    Breakpoint.MD { Modifier.height(40.px) }
}